import { Checkbox as AntdCheckbox } from 'antd';
import styled, { css } from 'styled-components';

export const CheckboxCss = css`
    line-height: 0;
    &.ant-checkbox-wrapper,
    & .ant-checkbox-wrapper {
        font-size: var(--button-font-size, 1rem);
        color: rgba(0, 0, 0, 0.85);

        align-items: flex-start;
        line-height: var(--checkbox-height, 1.5rem);

        &:hover .ant-checkbox::after {
            visibility: hidden;
        }
    }

    & .ant-checkbox {
        top: 0;

        & + span {
            display: inline-block;
            line-height: 1.5rem;
        }

        & .ant-checkbox-inner {
            width: var(--checkbox-width, 1.5rem);
            height: var(--checkbox-height, 1.5rem);
            background-color: rgb(255, 255, 255);
            border-color: rgb(98, 102, 105);
            border-radius: 0;
        }

        & .ant-checkbox-input {
            height: var(--checkbox-height, 1.5rem);
        }

        &:hover {
            & .ant-checkbox-inner {
                border-color: black;
            }
        }

        &:hover::after {
            visibility: hidden;
        }
    }

    & .ant-checkbox-indeterminate > .ant-checkbox-inner {
        &::after {
            background-color: #000;
            width: 16px;
            height: 16px;
        }
    }

    & .ant-checkbox-checked > .ant-checkbox-inner {
        border-color: rgb(50, 54, 57);
        background-color: rgb(50, 54, 57);
        border-radius: 0;

        &::after {
            border-width: 1px;
            border-color: #fff;
            transform: rotate(40deg) scale(1.5, 2.1) translate(-50%, -50%);
            top: 15px;
            left: 5px;
        }
    }
`;

const Checkbox = styled(AntdCheckbox)`
    ${CheckboxCss}
`;

export default Checkbox;
